// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1F0YU","left":"styles_left__mcp2-"};